<template>
<v-container fluid grid-list-xl class="text-xs-center pt-0 pb-0">
  <v-card class="pa-2 card-r shadow-1 grey lighten-4">
    <v-toolbar class="primary card-r pl-2 mb-3 text-white">
      <v-btn icon class="ma-0 primary text-white card-r no-shadow" to="/examstab#packages"> <v-icon>arrow_left</v-icon></v-btn>
      <div class="text-xs-left f-20 ml-3">Edit Package</div>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs6 class="pb-0">
        <v-text-field v-model="packagaData.name" solo label="Package Name"></v-text-field>
      </v-flex>
      <v-flex xs3 class="pb-0">
        <v-text-field solo v-model="packagaData.valid_for" label="valid Days"></v-text-field>
      </v-flex>
      <v-flex xs3 class="pb-0">
        <v-text-field solo v-model="packagaData.price" label="price"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-combobox solo :items="testsList" v-model="selectedTests" item-value="id"  item-text="name" label="Select Tests" multiple chips>
          <template slot="selection" slot-scope="data">

            <v-chip
              :selected="data.selected"
              :disabled="data.disabled"
              :key="JSON.stringify(data.item)"
              class="v-chip--select-multi"
              @input="data.parent.selectItem(data.item)">
              <!-- <v-avatar
                class="accent white--text"
                tile="true"
                size="36px"
                color="grey lighten-4">
                <img  :src="data.item.picture">
              </v-avatar> -->
              {{ data.item.name }}</v-chip>
          </template>
        </v-combobox>
      </v-flex>
      <v-flex xs12>
        <v-textarea v-model="packagaData.description" rows="2" solo name="input-7-1" label="Description"></v-textarea>
      </v-flex>
      <v-flex xs12>
        <v-progress-circular
          indeterminate
          v-if=loading
          color="primary"
        ></v-progress-circular>
        <v-alert
          :value="true"
          :type="alertType"
          :icon="alertType"
          v-if="alertMessage"
          outline>
          {{alertMessage}}
        </v-alert>
      </v-flex>
      <v-flex xs12 class="text-xs-right pa-0">
        <v-btn @click="updatePackage(packagaData.id)" color="primary card-r no-shadow right text-white" dark>Save</v-btn>
        <v-btn color="grey no-shadow right text-white" to="/examstab#packages" dark>cancel</v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</v-container>
</template>
<script>
  /*eslint-disable */

  import api from "@/utils/backend-api"
  import { mapState } from 'vuex'
  import router from "@/router"

  export default {
    props:['id'],
    data: () => ({
      loading:false,
      alertMessage:'',
      alertType:'',
      workMin: ['45', '90', '135', '180'],
      typs: ['Random', 'Mannual'],
      show: false,
      items: [
        'Tests 1',
        'Tests 2',
        'Tests 3',
        'Tests 4',
        'Tests 5',
        'Tests 6',
        'Tests 7',
        'Tests 8',
        'Tests 9',
        'Tests 10'
      ],
      packagaData:'',
      selectedTests:''
    }),
    created:function(){
      api.postData('driver/viewTestPackages/'+this.id)
      .then(res=>{
        
        this.packagaData=res.data
        this.selectedTests=res.data.test_data
        for(var i=1; i<this.selectedTests.length ; i++ ){
          return this.selectedTests
        }
      })

    },
    methods:{
      isEmpty(value){
        return (value == null || value.length === 0);
      },
      validateFields(){
        if(this.isEmpty(this.packagaData.name)){
          this.alertType="error"
          this.alertMessage="Package name is required"
          return false
        }else if(this.isEmpty(this.packagaData.valid_for)){
          this.alertType="error"
          this.alertMessage="Valid days are required"
          return false
        }else if(this.isEmpty(this.packagaData.price)){
          this.alertType="error"
          this.alertMessage="Price is required"
          return false
        }else if(this.isEmpty(this.selectedTests)){
          this.alertType="error"
          this.alertMessage="Minimum 1 test required"
          return false
        }
        return true
      },
      updatePackage(packageId){
        if(this.validateFields()){
            this.loading=true
            this.alertMessage=''
            this.alertType=''
            let self=this
            let theory_test=this.selectedTests
            let selectedTests=[]
            if(theory_test){
              theory_test.forEach(element => {
                selectedTests.push(element.id)
              });
            }

            let Data={
              valid_for:this.packagaData.valid_for,
              price:parseInt(this.packagaData.price),
              test_package_id:packageId,
              theory_test:selectedTests,
              description:this.packagaData.description,
              name:this.packagaData.name
            }
            api.postData('driver/updateTestPackage',Data)
            .then(res=>{
              if(res.status==201){
                self.loading=false
                self.alertMessage="Successfully created"
                self.alertType='success'
                router.push('/examstab#packages')
              }else{
                self.alertType='error'
                self.alertMessage="Failed to update"
              }

            }).catch(err=>{
              self.loading=false
              self.alertType='error'
              self.alertMessage="Failed to update"
            })
        }
      }
    },
    computed: {
      ...mapState({
        testsList: 'testsList',
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/EditPackages.vue